import React from 'react'
import PropTypes from 'prop-types'

import BookingDelivered from 'assets/icons/booking-delivered.svg'
import BookingSubmitted from 'assets/icons/booking-submitted.svg'
import BookingNotDelivered from 'assets/icons/booking-not-delivered.svg'

const BookingStateIcon = ({state, style}) => {
  const image = (src) =>
    <img alt={state} style={style} src={src} />

  switch (state) {
    case 'completed':
      return image(BookingDelivered)
    case 'submitted':
      return image(BookingSubmitted)
    default:
      return image(BookingNotDelivered)
  }
}

BookingStateIcon.propTypes = {
  state: PropTypes.string.isRequired,
  style: PropTypes.object,
}

BookingStateIcon.defaultProps = {
  style: {width: 45, height: 45},
}

export default BookingStateIcon
